import { Component, Inject, OnInit } from '@angular/core';
import { ModalComponent } from '../../../../shared/components/modal/modal.component';
import { InputComponent } from '../../../../shared/components/input/input.component';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastService } from '../../../../shared/services/toast.service';
import { IndexFaceRequest } from '../../../../shared/models/biometria';
import { ToastState as ts } from '../../../../shared/enums/toast-state.enum';
import { BiometriaService } from '../../../../shared/services/biometria.service';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { CpfMaskDirective } from '../../../../shared/directives/cpf-mask.directive';
import { CpfHelper } from '../../../../shared/helpers/cpf.helper';

@Component({
  selector: 'app-dialog-cadastro-parcial',
  imports: [
    ButtonComponent,
    ModalComponent,
    InputComponent,
    ReactiveFormsModule,
    CpfMaskDirective,
  ],
  templateUrl: './dialog-cadastro-parcial.component.html',
  styleUrl: './dialog-cadastro-parcial.component.scss',
})
export class DialogCadastroParcialComponent {
  form: FormGroup;
  selectedFile: File | null = null;
  previewUrl: string | ArrayBuffer | null = null;
  base64Image: string | null = null;

  constructor(
    private dialogRef: MatDialogRef<DialogCadastroParcialComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private service: BiometriaService,
    private toast: ToastService,
  ) {
    this.form = this.fb.group({
      driverId: [
        '',
        [
          Validators.required,
          Validators.minLength(14),
          Validators.maxLength(14),
        ],
      ],
      base64Image: [null, [Validators.required]],
    });
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];

      const reader = new FileReader();
      reader.onload = () => {
        this.previewUrl = reader.result;
        this.base64Image = reader.result as string;

        this.form.get('base64Image')?.setValue(this.base64Image);
      };
      reader.readAsDataURL(this.selectedFile);
    }
  }

  onSave(formData: any) {
    const cpfLimpo = formData.driverId
      ? CpfHelper.clean(formData.driverId)
      : '';

    if (cpfLimpo.length !== 11) {
      this.toast.showToast(
        ts.warning,
        'O CPF deve conter exatamente 11 dígitos.',
      );
      return;
    }

    if (!this.base64Image) {
      this.toast.showToast(ts.warning, 'Selecione uma foto da face.');
      return;
    }

    const dto: IndexFaceRequest = {
      driverId: cpfLimpo,
      base64Image: this.base64Image,
    };

    this.insert(dto);
  }

  private insert(data: IndexFaceRequest) {
    this.service.indexFace(data).subscribe({
      next: (result) => {
        if (result.success) {
          this.toast.showToast(ts.success, 'Motorista registrado com sucesso!');
          this.dialogRef.close(result.content);
        }
      },
      error: (e) => {
        const msg = e.error?.messages?.[0] || 'Erro ao registrar.';
        this.toast.showToast(ts.error, msg);
        this.dialogRef.close();
      },
    });
  }
}
